import { IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import CancelIcon from '@mui/icons-material/Cancel';
import { Link } from 'react-router-dom';
import { BOOKING_STATUSES } from '../../../../helpers/constants';
import { MODAL_TYPE } from '../../../../hooks/useModal';

function BookingRowActions({
    row,
    t,
    showModal,
    operatingId,
    onRefundReservation,
    onCancelReservation,
    canRefundBookings,
    canAlwaysRefund,
    canCancelBookings,
}) {
    // Refund stays FINISHED-only — refunding a PROCESSING booking is
    // nonsensical (no transactions have settled yet).
    const isRefundDisabled =
        row.status !== BOOKING_STATUSES.FINISHED ||
        operatingId === row.id ||
        row?.timeslot?.deleted === true;

    // Cancel additionally allows stale PROCESSING bookings that never got
    // any tickets — these get stuck (guest abandoned checkout / payment
    // failed) and agents had no way to clear them out before.
    const isStaleProcessing =
        row.status === BOOKING_STATUSES.PROCESSING && (row.ticketTypes?.length ?? 0) === 0;
    const isCancelDisabled =
        (row.status !== BOOKING_STATUSES.FINISHED && !isStaleProcessing) ||
        operatingId === row.id ||
        row?.timeslot?.deleted === true;

    return (
        <>
            {row?.timeslot?.deleted === true ? (
                <Tooltip title={t('common.edit')}>
                    <IconButton disabled>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <Link to={`/bookings/edit/${row.id}`}>
                    <Tooltip title={t('common.edit')}>
                        <IconButton>
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </Link>
            )}

            {(canRefundBookings || canCancelBookings) && !row?.limitedModification && (
                <>
                    {canRefundBookings && (
                        <Tooltip title={t('common.refundReservation')}>
                            <span>
                                <IconButton
                                    onClick={() => {
                                        showModal(MODAL_TYPE.REFUND_CONFIRMATION, {
                                            title: t('refundModal.title'),
                                            content: t('refundModal.content'),
                                            bookingId: row.id,
                                            startTime: row?.timeslot?.startTime,
                                            cancelWindow: row?.timeslot?.cancelWindow,
                                            confirm: (id, amount) =>
                                                onRefundReservation(id, amount),
                                        });
                                    }}
                                    disabled={isRefundDisabled}
                                >
                                    <RotateLeftIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}
                    {canCancelBookings && (
                        <Tooltip title={t('common.cancelReservation')}>
                            <span>
                                <IconButton
                                    onClick={() => {
                                        showModal(MODAL_TYPE.CANCELLATION_CONFIRMATION, {
                                            title: t('confirmationModal.title'),
                                            content: t('confirmationModal.content'),
                                            bookingId: row.id,
                                            startTime: row.timeslot?.startTime,
                                            cancelWindow: row?.timeslot?.cancelWindow,
                                            cancelDescription: row?.timeslot?.cancelDescription,
                                            alwaysRefund: canAlwaysRefund && !row?.invoiceId,
                                            confirm: (id, amount, opts) =>
                                                onCancelReservation(id, amount, opts),
                                        });
                                    }}
                                    disabled={isCancelDisabled}
                                >
                                    <CancelIcon />
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}
                </>
            )}
        </>
    );
}

export default BookingRowActions;
